import { supabase } from './supabaseClient';
import { getApiBaseUrl } from './compositionApi';

// Etat du site pour CE visiteur (mode test / maintenance) — voir backend/routes/appStatus.js.
// Route publique a authentification facultative : le jeton est joint s'il existe, afin qu'un testeur soit
// reconnu. Jamais bloquant : en cas d'erreur, l'appelant garde son dernier etat connu.
export const fetchAppStatus = async () => {
  let headers = {};
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) headers = { Authorization: `Bearer ${session.access_token}` };
  } catch (_error) { /* visiteur sans session */ }
  const response = await fetch(`${getApiBaseUrl()}/app/status`, {
    headers,
    cache: 'no-store',
    signal: AbortSignal.timeout(6000)
  });
  if (!response.ok) throw new Error('Etat du site indisponible');
  return response.json();
};

// Pays du visiteur deduit de son IP par le serveur (backend/routes/appStatus.js) : un code pays ou null.
export const fetchDetectedCountry = async () => {
  const response = await fetch(`${getApiBaseUrl()}/app/country`, { cache: 'no-store', signal: AbortSignal.timeout(4000) });
  if (!response.ok) return null;
  const { country } = await response.json();
  return country || null;
};
